// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jNUe","question":"styles_question__3iHfQ","description":"styles_description__9DL-C"};